import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/dario/data/sorgente/portaleFornitori/layouts/default.vue").then(m => m.default || m))
}